import type { OptionObjMustHaves } from '../interface-utils';

export const userOptions: OptionObjMustHaves[] = [
	{ id: 'all', value: 'Todos' },
	{ id: 'paid', value: 'Pagos' },
	{ id: 'unpaid', value: 'Sin Pago' }
];

export const enurmYear = {
	2021: '12/01/2020',
	2022: '10/01/2021',
	2023: '08/01/2022'
};

export const reportYearOptions: OptionObjMustHaves[] = [
	{ id: '2026', value: '2026' },
	{ id: '2025', value: '2025' }
];

export const questionBankOptions: OptionObjMustHaves[] = [
	{ id: 'enurm', value: 'ENURM' },
	{ id: 'prep+', value: 'Prep+' },
	{ id: 'maxilofacial', value: 'Maxilofacial' },
	{ id: 'dermatología', value: 'Dermatología' }
];

export const pruebasDiagnosticasOptions: OptionObjMustHaves[] = [
	{ id: 'evaluacion-1', value: 'Prueba Diagnóstica 1' },
	{ id: 'evaluacion-2', value: 'Prueba Diagnóstica 2' }
];

export const testTypeOptions: OptionObjMustHaves[] = [
	{ id: 'pruebín', value: 'Pruebín' },
	{ id: 'simulación', value: 'Simulación' },
	{ id: 'otro', value: 'Otro' }
];

// TODO: Need to separate these into 'default', 'admin', individual exams and 'evaluaciones diagnosticas' so Ican group the options in the select statement form
export const testLabelOptions = {
	enurmOnFreeTrial: [{ id: 'enurm-2020', value: 'ENURM 2020' }],
	enurmAdmin: [
		{ id: 'prepmed', value: 'Propietarias de PrepMed' },
		{ id: 'evaluacion-1', value: 'Evaluación Diagnóstica 1' },
		{ id: 'evaluacion-2', value: 'Evaluación Diagnóstica 2' },
		{ id: 'evaluacion-3', value: 'Evaluación Diagnóstica 3' },
		{ id: 'enurm-2025', value: 'ENURM 2025' },
		// { id: 'enurm-2025-B', value: 'ENURM 2025 B' },
		// { id: 'enurm-2025-C', value: 'ENURM 2025 C' },
		// { id: 'enurm-2025-D', value: 'ENURM 2025 D' },
		// { id: 'enurm-2025-E', value: 'ENURM 2025 D' },
		{ id: 'enurm-2024', value: 'ENURM 2024' },
		{ id: 'enurm-2023-A', value: 'ENURM 2023' },
		{ id: 'enurm-2022-A', value: 'ENURM 2022 A' },
		{ id: 'enurm-2022-B', value: 'ENURM 2022 B' },
		{ id: 'enurm-2022-C', value: 'ENURM 2022 C' },
		{ id: 'enurm-2022-D', value: 'ENURM 2022 D' },
		{ id: 'enurm-2021-A', value: 'ENURM 2021 A' },
		{ id: 'enurm-2021-B', value: 'ENURM 2021 B' },
		{ id: 'enurm-2021-C', value: 'ENURM 2021 C' },
		{ id: 'enurm-2020', value: 'ENURM 2020' },
		{ id: 'enurm-2019', value: 'ENURM 2019' },
		{ id: 'enurm-2018', value: 'ENURM 2018' },
		{ id: 'enurm-2017', value: 'ENURM 2017' },
		{ id: 'enurm-2016', value: 'ENURM 2016' },
		{ id: 'enurm-2015', value: 'ENURM 2015' },
		{ id: 'enurm-2014', value: 'ENURM 2014' },
		{ id: 'enurm-2013', value: 'ENURM 2013' },
		{ id: 'enurm-2012', value: 'ENURM 2012' },
		{ id: 'enurm-2011', value: 'ENURM 2011' },
		{ id: 'enurm-2010', value: 'ENURM 2010' },
		{ id: 'enurm-2009', value: 'ENURM 2009' },
		{ id: 'enurm-2008', value: 'ENURM 2008' },
		{ id: 'enurm-2007', value: 'ENURM 2007' },
		{ id: 'enurm-2006', value: 'ENURM 2006' },
		{ id: 'enurm-2005', value: 'ENURM 2005' },
		{ id: 'enurm-2004', value: 'ENURM 2004' },
		{ id: 'enurm-2003', value: 'ENURM 2003' },
		{ id: 'enurm-2002', value: 'ENURM 2002' },
		{ id: 'enurm-2001', value: 'ENURM 2001' }
	],
	maxilofacialAdmin: [
		{ id: 'all', value: 'Todas las Preguntas' },
		{ id: 'prepmed', value: 'Propietarias de PrepMed' },
		{ id: 'enurm-cmf-2025', value: 'ENURM CMF 2025' },
		{ id: 'enurm-cmf-2024', value: 'ENURM CMF 2024' },
		{ id: 'enurm-cmf-2023', value: 'ENURM CMF 2023' },
		{ id: 'enurm-cmf-2022', value: 'ENURM CMF 2022' },
		{ id: 'enurm-cmf-2021', value: 'ENURM CMF 2021' },
		{ id: 'enurm-cmf-2020', value: 'ENURM CMF 2020' },
		{ id: 'enurm-cmf-2019', value: 'ENURM CMF 2019' },
		{ id: 'enurm-cmf-2018', value: 'ENURM CMF 2018' },
		{ id: 'enurm-cmf-2017', value: 'ENURM CMF 2017' },
		{ id: 'enurm-cmf-2016', value: 'ENURM CMF 2016' },
		{ id: 'enurm-cmf-2012', value: 'ENURM CMF 2012' }
	],
	enurm: [
		{ id: 'all', value: 'Todas las Preguntas' },
		{ id: 'prepmed', value: 'Propietarias de PrepMed' },
		// { id: 'evaluacion-1', value: 'Evaluación Diagnóstica 1' },
		// { id: 'evaluacion-2', value: 'Evaluación Diagnóstica 2' },
		// { id: 'nuevas', value: 'Preguntas no antes vistas' },
		// TODO: Should I move these to questionTypeOptions?
		{ id: 'correctas', value: 'Solo Correctas' },
		{ id: 'incorrectas', value: 'Solo Incorrectas' },
		{ id: 'enurm-2025', value: 'ENURM 2025' },
		{ id: 'enurm-2024', value: 'ENURM 2024' },
		{ id: 'enurm-2023-A', value: 'ENURM 2023' },
		{ id: 'enurm-2022-A', value: 'ENURM 2022 A' },
		{ id: 'enurm-2022-B', value: 'ENURM 2022 B' },
		{ id: 'enurm-2022-C', value: 'ENURM 2022 C' },
		{ id: 'enurm-2022-D', value: 'ENURM 2022 D' },
		{ id: 'enurm-2021-A', value: 'ENURM 2021 A' },
		{ id: 'enurm-2021-B', value: 'ENURM 2021 B' },
		{ id: 'enurm-2021-C', value: 'ENURM 2021 C' },
		{ id: 'enurm-2020', value: 'ENURM 2020' },
		{ id: 'enurm-2019', value: 'ENURM 2019' },
		{ id: 'enurm-2018', value: 'ENURM 2018' },
		{ id: 'enurm-2017', value: 'ENURM 2017' },
		{ id: 'enurm-2016', value: 'ENURM 2016' },
		{ id: 'enurm-2015', value: 'ENURM 2015' },
		{ id: 'enurm-2014', value: 'ENURM 2014' },
		{ id: 'enurm-2013', value: 'ENURM 2013' },
		{ id: 'enurm-2012', value: 'ENURM 2012' },
		{ id: 'enurm-2011', value: 'ENURM 2011' },
		{ id: 'enurm-2010', value: 'ENURM 2010' },
		{ id: 'enurm-2009', value: 'ENURM 2009' },
		{ id: 'enurm-2008', value: 'ENURM 2008' },
		{ id: 'enurm-2007', value: 'ENURM 2007' }
		// { id: 'enurm-2006', value: 'ENURM 2006' },
		// { id: 'enurm-2005', value: 'ENURM 2005' },
		// { id: 'enurm-2004', value: 'ENURM 2004' },
		// { id: 'enurm-2003', value: 'ENURM 2003' },
		// { id: 'enurm-2002', value: 'ENURM 2002' },
		// { id: 'enurm-2001', value: 'ENURM 2001' }
	],
	maxilofacial: [
		{ id: 'all', value: 'Todas las Preguntas' },
		{ id: 'prepmed-cmf', value: 'Propietarias de PrepMed' },
		{ id: 'correctas', value: 'Solo Correctas' },
		{ id: 'incorrectas', value: 'Solo Incorrectas' },
		{ id: 'enurm-cmf-2025', value: 'ENURM CMF 2025' },
		{ id: 'enurm-cmf-2024', value: 'ENURM CMF 2024' },
		{ id: 'enurm-cmf-2023', value: 'ENURM CMF 2023' },
		{ id: 'enurm-cmf-2022', value: 'ENURM CMF 2022' },
		{ id: 'enurm-cmf-2021', value: 'ENURM CMF 2021' },
		{ id: 'enurm-cmf-2020', value: 'ENURM CMF 2020' },
		{ id: 'enurm-cmf-2019', value: 'ENURM CMF 2019' },
		{ id: 'enurm-cmf-2018', value: 'ENURM CMF 2018' },
		{ id: 'enurm-cmf-2017', value: 'ENURM CMF 2017' },
		{ id: 'enurm-cmf-2016', value: 'ENURM CMF 2016' },
		{ id: 'enurm-cmf-2012', value: 'ENURM CMF 2012' }
	],
	dermatología: [
		{ id: 'all', value: 'Todas las Preguntas' },
		{ id: 'prepderm', value: 'Propietarias de PrepMed' },
		{ id: 'bogaert', value: 'Bogaert' },
		{ id: 'correctas', value: 'Solo Correctas' },
		{ id: 'incorrectas', value: 'Solo Incorrectas' }
	],
	enarm: [],
	'prep+': [
		{ id: 'all', value: 'Todas las Preguntas' },
		{ id: 'prepmed', value: 'Propietarias de PrepMed' },
		{ id: 'prep+', value: 'Prep+' }
	]
};
// TODO: Where should these be used?
export const questionTypeOptions: OptionObjMustHaves[] = [
	{ id: 'todas', value: 'Todas las preguntas' },
	{ id: 'nuevas', value: 'Sólo preguntas nuevas' },
	{ id: 'repetidas', value: 'Sólo preguntas repetidas' }
];

export const testModeOptions: OptionObjMustHaves[] = [
	{ id: 'aleatorio', value: 'Modo Aleatorio' },
	{ id: 'categorías', value: 'Categorías Específicas' }
];

export const timerOptions: OptionObjMustHaves[] = [
	{ id: '60', value: '1 Minutos' }, // ENABLE FOR TESTING
	{ id: '1800', value: '30 Minutos' },
	{ id: '3599.9', value: '1 Hora' },
	{ id: '5400', value: '1 Hora y Media' },
	{ id: '7200', value: '2 Horas' },
	{ id: '9000', value: '2 Horas y Media' },
	{ id: '10800', value: '3 Horas' }
];

// *This array can then be used to generate the options in your select element in your React component:
// <select>
// {options.map((option, index) => (
// <option key={index} value={option.value} disabled={option.disabled}>
// {option.label}
// </option>
// ))}
// </select>;

export const prepPlusTemas: OptionObjMustHaves[] = [
	{
		id: 'diagnostico',
		value: 'Diagnóstico'
	},
	{
		id: 'manejo',
		value: 'Manejo'
	},
	{
		id: 'prevencion',
		value: 'Prevención'
	},
	{
		id: 'etica_profesionalismo',
		value: 'Ética / Profesionalismo'
	},
	{
		id: 'practica_basada_en_sistemas_seguridad_del_paciente',
		value: 'Práctica Basada en Sistemas / Seguridad del Paciente'
	},
	{
		id: 'ciencias_basicas',
		value: 'Ciencias básicas'
	}
];

export const prepPlusSistemas: OptionObjMustHaves[] = [
	{
		id: 'sistema_cardiovascular',
		value: 'Sistema Cardiovascular'
	},
	{
		id: 'sistema_gastrointestinal',
		value: 'Sistema Gastrointestinal'
	},
	{
		id: 'sistema_respiratorio',
		value: 'Sistema Respiratorio'
	},
	{
		id: 'sistema_musculoesqueletico_piel_y_tejido_subcutaneo',
		value: 'Sistema Musculoesquelético / Piel y Tejido Subcutáneo'
	},
	{
		id: 'sistema_nervioso_y_sentidos_especiales',
		value: 'Sistema Nervioso y Sentidos Especiales'
	},
	{
		id: 'sistema_hematologico_y_linfatico',
		value: 'Sistema Hematológico y Linfático'
	},
	{
		id: 'sistema_endocrino',
		value: 'Sistema Endocrino'
	},
	{
		id: 'sistema_reproductor_femenino_y_mama',
		value: 'Sistema Reproductor Femenino y Mama'
	},
	{
		id: 'procesos_y_trastornos_multisistemicos',
		value: 'Procesos y Trastornos Multisistémicos'
	},
	{
		id: 'sistema_renal_y_urinario_reproductor_masculino',
		value: 'Sistema Renal y Urinario & Reproductor Masculino'
	},
	{
		id: 'sistema_inmunologico',
		value: 'Sistema Inmunológico'
	}
];
